import { ThemeProvider } from '@mui/material/styles';

import "animate.css/animate.min.css";
import { appWithTranslation } from "next-i18next";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { RecoilRoot } from "recoil";
import "../assets/css/react-demo.css";
import "../assets/scss/nextjs-material-kit-pro.scss";
import Bugsnag from "../services/bugsnag";
// eslint-disable-next-line camelcase
import {
  cancelScheduledPageView,
  page_view,
  schedulePageViewAfterTitleUpdate,
} from "../services/gtag";
import "../styles/global.scss";
import theme from "../styles/theme";
import initAuth from "../utilities/initAuth";
import Error from "./_error";

initAuth();
const ErrorBoundary = Bugsnag.getPlugin("react");

// eslint-disable-next-line react/prop-types
const App = ({ Component, pageProps }) => {
  const router = useRouter();
  const [isGtmReady, setIsGtmReady] = useState(false);
  const initialPageViewSent = useRef(false);

  useEffect(() => {
    const markGtmReady = () => setIsGtmReady(true);
    window.addEventListener('playwhat:gtm-ready', markGtmReady);

    if (window.playwhatGtmReady) markGtmReady();

    return () => window.removeEventListener('playwhat:gtm-ready', markGtmReady);
  }, []);

  useEffect(() => {
    if (!isGtmReady) return;

    const handleRouteChange = () => schedulePageViewAfterTitleUpdate();
    if (!initialPageViewSent.current) {
      page_view();
      initialPageViewSent.current = true;
    }

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      cancelScheduledPageView();
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [isGtmReady, router.events]);

  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector("#jss-server-side");
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);

  return (
    <RecoilRoot>
      <ErrorBoundary FallbackComponent={Error}>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=6.0"
          />
        </Head>
        <ThemeProvider theme={theme}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          {/* <CssBaseline /> */}
          <Component {...pageProps} />
        </ThemeProvider>
      </ErrorBoundary>
    </RecoilRoot>
  );
};

export default appWithTranslation(App);
